module.exports = __webpack_public_path__ + "img/arrow_back_ios_black_24dp.9a67c156.svg";